var createTypedArrayConstructor = require('../internals/typed-array-constructor'); // `Uint32Array` constructor
// https://tc39.github.io/ecma262/#sec-typedarray-objects


createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});